module.exports = __webpack_public_path__ + "img/icon-green-check.77e7ef55.svg";